import React, { Component } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';

import { FormDataText } from '../../../../styles/sharedUIElemStyles';

export interface Props {
  /** przekazana watość do wyświetlenia */
  value: {
    data: string | Component | Function;
  };
}
/**
 * Komponent wartości nieedytowalnej
 *
 */
const Text = (props: Props): React.ReactElement => {
  const { t } = useTranslation();

  if (props.value.data && typeof props.value.data === 'string') {
    return <FormDataText>{props.value.data}</FormDataText>;
  } else if (!props.value.data) {
    return <FormDataText warning>{t('NO_DATA')}</FormDataText>;
  } else {
    return <Alert message={t('UNSUPPORTED_DATA_FORMAT')} type='error' />;
  }
};

export default Text;
